import { cx } from "@emotion/css";
import { X } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useFontSize } from "src/hooks/useFontSize";

interface AccountUser {
	hasAccess?: boolean;
	hasLimitedAccess?: boolean;
}

const LossItem = ({ children }: { children: ReactNode }) => {
	const { modalTextFontSizeClass } = useFontSize();

	return (
		<li className={cx("flex items-center gap-12", modalTextFontSizeClass)}>
			<X className="icon-small icon-error" />
			<span>{children}</span>
		</li>
	);
};

interface DeleteAccountLossesProps {
	user: AccountUser;
}

export const DeleteAccountLosses = ({ user }: DeleteAccountLossesProps) => {
	const { t } = useTranslation();
	const { modalHeaderFontSizeClass } = useFontSize();
	const hasPaidAccess = user.hasAccess && !user.hasLimitedAccess;

	return (
		<div className="delete-item-modal--danger-box delete-item-modal--losses">
			<strong className={modalHeaderFontSizeClass}>
				{t("modals.deleteItem.account.lossesTitle", "Bezpowrotnie stracisz:")}
			</strong>
			<ul>
				<LossItem>
					{t(
						"modals.deleteItem.account.lossExams",
						"wszystkie zgromadzone dane",
					)}
				</LossItem>
				<LossItem>
					{t(
						"modals.deleteItem.account.lossStats",
						"statystyki i historię nauki",
					)}
				</LossItem>
				{hasPaidAccess && (
					<LossItem>
						{t(
							"modals.deleteItem.account.lossPlan",
							"pozostały dostęp do serwisu — bez zwrotu",
						)}
					</LossItem>
				)}
			</ul>
		</div>
	);
};
